import { withDataConverter, withMountListener } from '@beef/react';
import { RequestStatus } from '@beef/smart-kit';
import { compose } from '@beef/utils';
import React from 'react';
import { findFirst } from "../../utils/arrays";
import { RequestStatusRedesign } from "../RequestStatus/RequestStatusRedesign";
import { converter } from "./converter";
export var EnhancedRequestStatus = compose(withDataConverter(converter), withMountListener)(function (props) {
  var Component = findFirst([props.isRedesign && RequestStatusRedesign, RequestStatus]);
  return /*#__PURE__*/React.createElement(Component, props);
});